export const PAGE_LEVEL_ERROR = "PAGE_LEVEL_ERROR";

export const GLOBAL_ERROR = "GLOBAL_ERROR";

export const UPDATE_USER = "UPDATE_USER";

export const UPDATE_ALERT = "UPDATE_ALERT";

export const UPDATE_BASE_CURRENCY = 'UPDATE_BASE_CURRENCY';

export const UPDATE_SELECTED_MARKET_ID = 'UPDATE_SELECTED_MARKET_ID';


export enum GRAPH_TYPES {
    'ABSOLUTE_VALUES' = 'absolute-values',
    'PERCENTAGES' = 'percentages',
    'MULTIPLES' = 'multiples',
    'DAYS' = 'days'
}